/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const polygon_chain_about = () => `Polygon, formerly Matic Network, is a blockchain platform designed to establish a multi-chain system compatible with Ethereum. It employs a proof-of-stake consensus mechanism similar to Ethereum for on-chain transactions, with its native token being MATIC. Functioning as a "layer two" or "sidechain" scaling solution alongside Ethereum, Polygon facilitates quicker transactions and lower fees. Its inception aimed to tackle Ethereum's major challenges, including high fees, subpar user experience, and limited transaction throughput, aspiring to create an "Ethereum's internet of blockchains" or a multi-chain ecosystem of Ethereum-compatible blockchains.`
